export default __webpack_public_path__ + "static/media/sobrepeso_trans.9b20e493.svg";